import React from 'react';
import { Marker, OverlayView, Circle } from '@react-google-maps/api';
import TransferDetails from './helper-components/TransferDetails';

const MapPointPickup = ({ index, shape, color = '#00A2F5', clusterer }) => {
    const { center, accuracy } = shape;

    const circleIcon = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 1,
        scale: 10,
        strokeWeight: 0,
    };

    const getPixelPositionOffset = (width, height) => ({
        x: -(width / 2),
        y: -height, // Adjust the value to position the bottom center of the SVG
    });

    return (
        <>
            <Marker
                key={shape._id}
                position={center}
                icon={circleIcon}
                clusterer={clusterer}
                onLoad={(marker) => {
                    // append shape data to marker for tracking in clusters
                    // eslint-disable-next-line no-param-reassign
                    marker.__data = shape;
                }}
                // wrap
            />
            {accuracy && (
                <Circle
                    center={center}
                    radius={accuracy}
                    options={{
                        strokeColor: color,
                        strokeOpacity: 0.3,
                        strokeWeight: 1,
                        fillColor: color,
                        fillOpacity: 0.1,
                        clickable: false,
                        draggable: false,
                        editable: false,
                        visible: true,
                        zIndex: 1,
                    }}
                />
            )}
            <OverlayView
                key={index}
                position={center}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={getPixelPositionOffset}
                // wrap
            >
                <TransferDetails
                    name={shape.name}
                    volume={shape.volume}
                    date={shape.date}
                    // wrap
                />
            </OverlayView>
        </>
    );
};

export default React.memo(MapPointPickup);
